var isChildType = function isChildType(child, component) {
  try {
    var _child$type;

    if (component != null && component.displayName && child != null && (_child$type = child.type) != null && _child$type.displayName) {
      return component.displayName === child.type.displayName;
    }
  } catch (_unused) {
    console.error("Unable to match React children type");
  }

  return false;
};

export default isChildType;
export { isChildType };
//# sourceMappingURL=isChildType.js.map
